<template>
  <div class="page">

    <div v-show="selectPosition" class="map">
      <iframe id="mapPage" width="100%" height="100%" frameborder=0
          src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=XZIBZ-MBCWP-VZ3D6-V2YPH-UVRCF-ARFRA&referer=ZMXCLMK">
      </iframe>
    </div>
    <h3 class="page__title">链点营销策略</h3>

    <hr/>
    <a @click="preAdd" style="width:100%;text-align:right;text-underline-offset: 1px;"><i class="bi bi-file-earmark-plus"></i> 增加策略 </a> |
    <a @click="refresh" style="width:100%;text-align:right;text-underline-offset: 1px;"><i class="bi bi-arrow-clockwise"></i> 刷新 </a>

    <div v-if="addForm == true">
      <div class="weui-form-preview" >
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">触发事件</label>
            <span class="weui-form-preview__value"  @click="pickEvent">{{getEventName(curAwardPolicy.event)}}<i class="bi bi-pencil-square"></i></span>

          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">领取条件</label>
            <span class="weui-form-preview__value"><!--{{itm.rule_json}}-->
            <table >
              <tbody  >
                <tr >
                  <td>位置</td><td>
                    <input type="number" class="half" placeholder="输入经度" v-model="curAwardPolicy.awardPolicyDTO.locations[0].longitude" />，
                    <input type="number" class="half" placeholder="输入维度" v-model="curAwardPolicy.awardPolicyDTO.locations[0].latitude" />
                  <i class="bi bi-geo-alt-fill" @click="fillPosition"></i><i class="bi bi-pencil-square"></i></td>
                </tr>
                <tr><td>距离</td><td>
                  <input type="number" class="half" placeholder="最大距离，米" v-model="curAwardPolicy.awardPolicyDTO.distance"/>米
                  <i class="bi bi-pencil-square"></i></td></tr>
                <tr><td>次数</td><td>
                  <input type="number" class="half" placeholder="最大次数" v-model="curAwardPolicy.awardPolicyDTO.userMaxTimes"/>次
                  <i class="bi bi-pencil-square"></i></td></tr>
              </tbody>
            </table>

            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">赠送单位</label>
            <span class="weui-form-preview__value"   @click="pickUnit">{{getUnitName(curAwardPolicy.unit)}}<i class="bi bi-pencil-square"></i></span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">赠送用户</label>
            <span class="weui-form-preview__value">
              <input type="number" class="half" placeholder="用户获得的链点数,或百分比（如0.01代表1%）" v-model="curAwardPolicy.userAward"/>
              <span v-if="curAwardPolicy.unit == 1">滴</span>
              <span v-else-if="curAwardPolicy.unit == 2">等价{{ curAwardPolicy.userAward * 100 }}%</span>
              <i class="bi bi-pencil-square"></i>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">赠送代理</label>
            <span class="weui-form-preview__value">
              <input type="number" class="half" placeholder="代理获得的链点数,或百分比（如0.01代表1%）" v-model="curAwardPolicy.agentAward"/>
              <span v-if="curAwardPolicy.unit == 1">滴</span>
              <span v-else-if="curAwardPolicy.unit == 2"> 等价{{ curAwardPolicy.agentAward * 100 }}%</span>
              <i class="bi bi-pencil-square"></i>

            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">总费用</label>
            <span class="weui-form-preview__value" >
              <input type="number" placeholder="计划投入的总费用" v-model="curAwardPolicy.totalAmount"/>滴
              <i class="bi bi-pencil-square"></i></span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">开始时间</label>
            <span class="weui-form-preview__value"  @click="pickBeginDate('开始时间')">{{curAwardPolicy.beginTime}}<i class="bi bi-pencil-square"></i></span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">结束时间</label>
            <span class="weui-form-preview__value"  @click="pickEndDate('结束时间')">{{curAwardPolicy.endTime}}<i class="bi bi-pencil-square"></i></span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注信息</label>
            <span class="weui-form-preview__value" >
              <input type="text" placeholder="请录入备注信息" v-model="curAwardPolicy.policyDesc"/>
              <i class="bi bi-pencil-square"></i></span>
          </div>
      </div>

      <div class="weui-form-preview__ft" >
          <a class="weui-form-preview__btn weui-form-preview__btn_primary" @click="add">确认</a>
          <a class="weui-form-preview__btn weui-form-preview__btn_primary" @click="addCancel" >取消</a>
      </div>
    </div>
    </div>
    <div v-else>
      <div v-if="awardPolicyList.length == 0">
        您还没有配置任何营销策略；
      </div>

      <div v-else class="weui-form-preview" v-for="itm in awardPolicyList" :key="itm.id">
        <div class="weui-form-preview__hd">
          <label class="weui-form-preview__label">ID</label>
          <em class="weui-form-preview__value">{{itm.partner_id}}_{{itm.id}}</em>
        </div>
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">触发事件</label>
            <span class="weui-form-preview__value" v-if="itm.id != curAwardId">{{getEventName(itm.event)}}</span>
            <span class="weui-form-preview__value" v-else @click="pickEvent">{{getEventName(curAwardPolicy.event)}}<i class="bi bi-pencil-square"></i></span>

          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">领取条件</label>
            <span class="weui-form-preview__value"><!--{{itm.rule_json}}-->


            <table v-if="itm.id != curAwardId">
              <tbody  v-if="(itm.jsonRule != null )">
                <tr v-for="location in itm.jsonRule.locations" :key="location.latitude + location.longitude">
                  <td>位置</td><td>经纬度：({{location.longitude}},{{location.latitude}}) </td>
                </tr>
                <tr><td>距离</td><td>{{itm.jsonRule.distance}}米</td></tr>
                <tr><td>次数</td><td>{{itm.jsonRule.userMaxTimes}}次</td></tr>
              </tbody>
            </table>

            <table v-else>
              <tbody  v-if="(curAwardPolicy.awardPolicyDTO != null )">
                <tr v-for="(location,idx) in curAwardPolicy.awardPolicyDTO.locations" :key="idx">
                  <td>位置</td><td>
                    <input type="number" class="half" placeholder="输入经度" v-model="location.longitude" />，
                    <input type="number" class="half" placeholder="输入维度" v-model="location.latitude" />
                  <i class="bi bi-geo-alt-fill" @click="fillPosition"></i><i class="bi bi-pencil-square"></i></td>
                </tr>
                <tr><td>距离</td><td>
                  <input type="number" class="half" placeholder="最大距离，米" v-model="curAwardPolicy.awardPolicyDTO.distance"/>米
                  <i class="bi bi-pencil-square"></i></td></tr>
                <tr><td>次数</td><td>
                  <input type="number" class="half" placeholder="最大次数" v-model="curAwardPolicy.awardPolicyDTO.userMaxTimes"/>次
                  <i class="bi bi-pencil-square"></i></td></tr>
              </tbody>
            </table>

            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">赠送单位</label>
            <span class="weui-form-preview__value" v-if="itm.id != curAwardId">{{getUnitName(itm.unit)}}</span>
            <span class="weui-form-preview__value" v-else  @click="pickUnit">{{getUnitName(curAwardPolicy.unit)}}<i class="bi bi-pencil-square"></i></span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">赠送用户</label>
            <span class="weui-form-preview__value" v-if="itm.id != curAwardId">{{itm.user_award}}
              <span v-if="itm.unit == 1">滴</span>
              <span v-else-if="itm.unit == 2">等价{{ itm.user_award * 100 }}%</span>
            </span>
            <span class="weui-form-preview__value" v-else>
              <input type="number" class="half" placeholder="用户获得的链点数" v-model="curAwardPolicy.userAward"/>
              <span v-if="curAwardPolicy.unit == 1">滴</span>
              <span v-else-if="curAwardPolicy.unit == 2">等价{{ curAwardPolicy.userAward * 100 }}% </span><i class="bi bi-pencil-square"></i>
            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">赠送代理</label>
            <span class="weui-form-preview__value" v-if="itm.id != curAwardId">{{itm.agent_award}}
              <span v-if="itm.unit == 1">滴</span>
              <span v-else-if="itm.unit == 2">等价{{ itm.agent_award * 100 }}%</span>
            </span>
            <span class="weui-form-preview__value" v-else>
              <input type="number" class="half" placeholder="代理获得的链点数" v-model="curAwardPolicy.agentAward"/>
              <span v-if="curAwardPolicy.unit == 1">滴</span>
              <span v-else-if="curAwardPolicy.unit == 2">等价{{ curAwardPolicy.agentAward * 100 }}%</span><i class="bi bi-pencil-square"></i>

            </span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">总费用</label>
            <span class="weui-form-preview__value"  v-if="itm.id != curAwardId">{{itm.total_amount}}</span>
            <span class="weui-form-preview__value" v-else>
              <input type="number" placeholder="计划投入的总费用" v-model="curAwardPolicy.totalAmount"/>滴
              <i class="bi bi-pencil-square"></i></span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">已消耗</label>
            <span class="weui-form-preview__value" >{{itm.awarded_amount}}滴</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">开始时间</label>
            <span class="weui-form-preview__value" v-if="itm.id != curAwardId"  >{{itm.begin_time}}</span>
            <span class="weui-form-preview__value" v-else @click="pickBeginDate('开始时间')">{{curAwardPolicy.beginTime}}<i class="bi bi-pencil-square"></i></span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">结束时间</label>
            <span class="weui-form-preview__value" v-if="itm.id != curAwardId">{{itm.end_time}}</span>
            <span class="weui-form-preview__value" v-else  @click="pickEndDate('结束时间')">{{curAwardPolicy.endTime}}<i class="bi bi-pencil-square"></i></span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">创建时间</label>
            <span class="weui-form-preview__value">{{itm.create_time}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">修改时间</label>
            <span class="weui-form-preview__value">{{itm.modify_time}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">生效状态</label>
            <span class="weui-form-preview__value">{{getStateName(itm.state)}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注信息</label>
            <span class="weui-form-preview__value" v-if="itm.id != curAwardId">{{itm.desc}}</span>
            <span class="weui-form-preview__value" v-else>
              <input type="text" placeholder="请录入备注信息" v-model="curAwardPolicy.policyDesc"/>
              <i class="bi bi-pencil-square"></i></span>
          </div>


          <div class="weui-form-preview__item" >
            <label class="weui-form-preview__label">二维码背景色</label>
            <input type="text" placeholder="" v-model="qr_color_light"/>
          </div>
          <div class="weui-form-preview__item" >
            <label class="weui-form-preview__label">二维码前景色</label>
            <input type="text" placeholder="" v-model="qr_color_dark"/>
          </div>
          <div class="weui-form-preview__item" v-show="qr_content.length > 4">
            <label class="weui-form-preview__label">二维码内容</label>
            <span class="weui-form-preview__value">{{qr_content}}</span>
          </div>
      </div>

      <div>
        <canvas :id="genCanvasID(itm.id)" class="NO"></canvas>

      </div>

      <div class="weui-form-preview__ft" v-if="curAwardId != itm.id">
          <a class="weui-form-preview__btn weui-form-preview__btn_primary" @click="del(itm.id)">删除</a>
          <a class="weui-form-preview__btn weui-form-preview__btn_primary" @click="update(itm)" >修改</a>
          <a class="weui-form-preview__btn weui-form-preview__btn_primary" @click="showQRCode(itm)" v-if="(itm.qr_flag == true) && (itm.event == 5)">隐藏二维码</a>
          <a class="weui-form-preview__btn weui-form-preview__btn_primary" @click="showQRCode(itm)" v-if="(itm.qr_flag == false) && (itm.event == 5)">展示二维码</a>
      </div>
      <div class="weui-form-preview__ft" v-else>
          <a class="weui-form-preview__btn weui-form-preview__btn_primary" @click="updateConfirm">确认修改</a>
          <a class="weui-form-preview__btn weui-form-preview__btn_primary" @click="updateCancel" >取消修改</a>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import axios from 'axios'

import qrcode from 'qrcode'
import JQ from 'jquery'


function get2Str(str){
  return padding1(str,2);
}
function padding1(num, length) {
  for(var len = (num + "").length; len < length; len = num.length) {
   num = "0" + num;
  }
  return num;
 }

  export default {
    data () {
      return {
        qr_content:"",
        qr_color_light:"#ffffff",
        qr_color_dark:"#832502",
        selectPosition:false,
        addForm:false,
        awardPolicyList:[],
        partnerid:"",
        curAwardId:-1,
        curAwardPolicy:null,
        addAwardPolicy:null,
        eventList: [{
              label: '关注公众号',
              value: 1
          }, {
              label: '填写车牌号',
              value: 2
          }, {
              label: '填写车牌号',
              value: 3
          }, {
              label: '微信支付',
              value: 4
          },{
              label: '扫码领取',
              value: 5
        }],
        stateList: [{
              label: '生效中',
              value: 1
          }, {
              label: '失效',
              value: 2
          }, {
              label: '失效',
              value: 3
          }, {
              label: '失效',
              value: 4
          },{
              label: '失效',
              value: 5
        }],
        unitList: [{
              label: '滴',
              value: 1
          }, {
              label: '百分比',
              value: 2
          }]
      }
    },
    mounted() {
      this.partnerid = sessionStorage.getItem("partnerid")

      this.getAwardPolicyList(this.partnerid)
    },
    methods: {
      genCanvasID(aid){
        return 'QR_CANVAS_AID_'+aid;
      },

      showQRCode(ap){

        let aid = ap.id;
        let content = "https://zmxcl.nationaiot.com/customer/awardQRCode?awardId="+ap.id;

        this.qr_content = content;


        console.log(content)

        if(ap.qr_flag){
          JQ('#'+this.genCanvasID(aid)).attr('class','NO')
          ap.qr_flag = false;
          this.qr_content = "";
        }else{

         qrcode.toCanvas(
          document.getElementById(this.genCanvasID(aid)),
          content,
          {width:200,height:200,toSJISFunc:qrcode.toSJISFunc,color:{light:this.qr_color_light,dark:this.qr_color_dark}},
          error => {console.log(error)}

         )

         JQ('#'+this.genCanvasID(aid)).attr('class','YES')
         ap.qr_flag = true;
        }
      },
      fillPosition(){
        this.curAwardPolicy.awardPolicyDTO.locations = [];
        var loc = new Object();

        loc.latitude = sessionStorage.getItem("mylat");
        loc.longitude = sessionStorage.getItem("mylng");

        this.curAwardPolicy.awardPolicyDTO.locations.push(loc);

        this.selectPosition = true;

        this.addMapEventHandler();
      },
      addMapEventHandler(){
        let that = this;
        window.addEventListener('message',
          function(event) {
            // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
            var loc = event.data;
            if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
              console.log('location', loc);
              that.curAwardPolicy.awardPolicyDTO.locations = [];
              var locTemp = new Object();
              locTemp.latitude = loc.latlng.lat;
              locTemp.longitude = loc.latlng.lng;
              that.curAwardPolicy.awardPolicyDTO.locations.push(locTemp);

              that.selectPosition = false;
            }
          },
          false
        );
      },
      del(aid){
        console.log("showdata")
        let that = this;
        this.ing=true;
        axios.get('/customer//omc/deleteAwardPolciy?awardId='+aid).then(res  =>  {
          console.log(res.data)
          if((res.data == null)) {
            alert("系统繁忙，请稍后重试")
            return;
          }
          if(res.data.retcode == 0)
            alert("删除成功")
          this.getAwardPolicyList(this.partnerid)
        })
      },
      preAdd(){
        console.log("preAdd")
        this.curAwardId = -1;
        this.initValue();
        this.addForm = true;
      },
      addCancel(){
        console.log("addCancel")
        this.addForm = false;
      },
      add(){
        let that = this;
        console.log("add")
        axios.post('customer/omc/qrcodeAwardPolicyCfg',this.curAwardPolicy).then(res  =>  {
          console.log(res.data)
          if((res.data == null)) {
            alert("系统繁忙，请稍后重试")
            return;
          }
          if(res.data.retcode == 0)
          {
             if(that.curAwardPolicy.id != null) alert("修改成功"); else alert("增加成功");
          }

          else{
            if(res.data.retmsg.indexOf('Duplicate') >= 0)
              alert("事件【"+ that.getEventName( that.curAwardPolicy.event)+"】存在重复的营销策略，可直接修改。");
            else
              alert(res.data.retmsg)
          }
          this.getAwardPolicyList(this.partnerid)
        })
      },
      refresh(){
        this.getAwardPolicyList(this.partnerid)
      },
      initValue(){
        console.log("initValue begin:",this.curAwardPolicy)


        this.curAwardId = -1;

        this.curAwardPolicy = {
          "partnerId":sessionStorage.getItem("partnerid"),
          "event":1,
          "agentAward":1,
          "userAward":1,
          "unit":1,
          "awardPolicyDTO": {
            "locations": [
              {
                "longitude": 0,
                "latitude": 0
              }
            ],
            "distance": 1000,
            "userMaxTimes": 1
          },
          "totalAmount": 50000,
          "beginTime": new Date().Format("yyyy-MM-dd 00:00:00"),
          "endTime": new Date().Format("yyyy-12-31 23:59:59") ,
          "policyDesc": ""

        };
        console.log("initValue end:",this.curAwardPolicy)
      },
      cpValue(itm){
        console.log("CPVALUE:",this.curAwardPolicy)

        this.initValue();

        this.curAwardPolicy.partnerid = itm.partner_id;
        this.curAwardPolicy.event = itm.event;
        this.curAwardPolicy.agentAward = itm.agent_award;
        this.curAwardPolicy.userAward = itm.user_award;
        this.curAwardPolicy.unit = itm.unit;
        this.curAwardPolicy.totalAmount = itm.total_amount;
        this.curAwardPolicy.beginTime = itm.begin_time;
        this.curAwardPolicy.endTime = itm.end_time;
        this.curAwardPolicy.policyDesc = itm.desc;
        //
        if(itm.jsonRule != null){
          this.curAwardPolicy.awardPolicyDTO.distance = itm.jsonRule.distance;
          this.curAwardPolicy.awardPolicyDTO.userMaxTimes = itm.jsonRule.userMaxTimes;

          this.curAwardPolicy.awardPolicyDTO.locations = [];

          for(let lc of JSON.parse(itm.jsonRule).locations){
            let lcCP = new Object();
            lcCP.latitude = lc.latitude;
            lcCP.longitude = lc.longitude;

            this.curAwardPolicy.awardPolicyDTO.locations.push(lcCP);
          }
        }
        console.log(this.curAwardPolicy)
      },
      update(itm){
        // 要避免引用，会直接修改itm本身
        this.cpValue(itm);

        this.curAwardId = itm.id;
      },
      updateConfirm(){
        console.log("updateConfirm")
        this.curAwardPolicy.id=this.curAwardId;
        this.add();
      },

      updateCancel(){
        this.curAwardId = -1;
        this.curAwardPolicy = null;
      },
      setData(itm){

      },
      pickEvent() {
      let that = this;
      this.$weui.picker(this.eventList, {
            onChange: function (result) {
                console.log(result);
                that.curAwardPolicy.event = result[0].value
            },
            onConfirm: function (result) {
                console.log(result);
            },
            title: '选择触发事件'
        });
    },
    pickUnit() {
      let that = this;
      this.$weui.picker(this.unitList, {
            onChange: function (result) {
                console.log(result);
                that.curAwardPolicy.unit = result[0].value
            },
            onConfirm: function (result) {
                console.log(result);
            },
            title: '选择触发事件'
        });
    },
    pickBeginDate(title) {
      let that = this;
      this.$weui.datePicker({
            start: 2022,
            end: new Date().getFullYear(),
            onChange: function (result) {
                console.log(result);
            },
            onConfirm: function (result) {
                console.log(result);
                that.curAwardPolicy.beginTime = result[0].value +"-"+ get2Str(result[1].value) +"-"+ get2Str(result[2].value) + " 00:00:00";
            },
            title: title
        });
    },
    pickEndDate(title) {
      let that = this;
      this.$weui.datePicker({
            start: 2022,
            end: new Date().getFullYear(),
            onChange: function (result) {
                console.log(result);
            },
            onConfirm: function (result) {
                console.log(result);
                that.curAwardPolicy.endTime  = result[0].value +"-"+ get2Str(result[1].value) +"-"+ get2Str(result[2].value) + " 23:59:59";
            },
            title: title
        });
    },
      getEventName(eid){
        for(var evt of this.eventList){
          // console.log("evt:",evt)
          if(evt.value == eid)
            return evt.label;
        }
        return eid;
      },
      getUnitName(eid){
        for(var evt of this.unitList){
          // console.log("evt:",evt)
          if(evt.value == eid)
            return evt.label;
        }
        return eid;
      },
      getStateName(eid){
        for(var evt of this.stateList){
          // console.log("evt:",evt)
          if(evt.value == eid)
            return evt.label;
        }
        return eid;
      },
      getAwardPolicyList(pid){
        console.log("showdata")

        this.initValue();

        let that = this;
        this.ing=true;
        axios.get('zmomc/awardPolicy?partnerid='+this.partnerid).then(res  =>  {
          console.log(res.data)
          if((res.data == null)) {
            return;
          }
          that.stData(res.data)
          that.awardPolicyList=res.data
        })

      },
      stData(data){
        console.log('data',data);
        for(let itm of data){
          itm.jsonRule = itm.rule_json;

          itm.qr_flag =false;
        }
      }

    }
  }
  </script>

  <style>
    input.right{align-content: right;text-align: right;align-self: right;width:3em}
    input.center{align-content: center;text-align: center;align-self: center;width:3em}
    table{width:100%}
    input.half{width:80px}
    canvas.NO{display:none;}

    canvas.YES{display:block;align-self: center;margin: 0 auto;}
    .map{
      height: 100vh;
      width: 100vw;
    }
  </style>



// WEBPACK FOOTER //
// src/views/operation_mgr.vue